import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/alert-warning/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/alert-warning/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/alert-warning/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconAlertWarning16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Yellow warning triangle with exclamation point`, id: 'icon.title.alert-warning', comment: 'Title for alert warning icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-alert-warning-16-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" d="M.245 12.01 6.159 1.083c.782-1.445 2.9-1.445 3.682 0l5.914 10.925c.734 1.357-.271 2.991-1.84 2.991H2.084C.517 15-.49 13.366.246 12.01Z"></path><path fill="#fff" fill-rule="evenodd" d="M8 3.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 8 3.25Z" clip-rule="evenodd"></path><path fill="#fff" d="M8.8 11.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"></path></svg>`; }
}
if (!customElements.get('w-icon-alert-warning-16')) {
  customElements.define('w-icon-alert-warning-16', IconAlertWarning16);
}